/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Breakdown_Kind_Direct_Member_DiscountInputs */

const en_price_breakdown_kind_direct_member_discount = /** @type {(inputs: Price_Breakdown_Kind_Direct_Member_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direct member discount`)
};

/**
* | output |
* | --- |
* | "Direct member discount" |
*
* @param {Price_Breakdown_Kind_Direct_Member_DiscountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_breakdown_kind_direct_member_discount = /** @type {((inputs?: Price_Breakdown_Kind_Direct_Member_DiscountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Breakdown_Kind_Direct_Member_DiscountInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_breakdown_kind_direct_member_discount(inputs)
});